import { render, staticRenderFns } from "./SecondChildAction.vue?vue&type=template&id=3155794e&scoped=true&"
import script from "./SecondChildAction.vue?vue&type=script&lang=js&"
export * from "./SecondChildAction.vue?vue&type=script&lang=js&"
import style0 from "./SecondChildAction.vue?vue&type=style&index=0&id=3155794e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3155794e",
  null
  
)

export default component.exports